import { createSlice } from "@reduxjs/toolkit";

function asyncSlice({ adapter, name, initialState, reducers }) {
  const defaultInitialState = {
    data: adapter?.getInitialState(),
    error: null,
    loading: false,
  };
  return createSlice({
    name,
    initialState: initialState || defaultInitialState,
    reducers: {
      setError(draft, action) {
        draft.error = action.payload;
        draft.loading = false;
      },
      setLoading(draft) {
        draft.error = null;
        draft.loading = true;
      },
      unsetLoading(draft) {
        draft.error = null;
        draft.loading = false;
      },
      addOne(draft, action) {
        if (!adapter?.addOne) return;
        adapter.addOne(draft.data, action.payload);
        draft.error = null;
        draft.loading = false;
      },
      addMany(draft, action) {
        if (!adapter?.addMany) return;
        adapter.addMany(draft.data, action.payload);
        draft.error = null;
        draft.loading = false;
      },
      set(draft, action) {
        draft.data = action.payload;
        draft.error = null;
        draft.loading = false;
      },
      setAll(draft, action) {
        if (!adapter?.setAll) return;
        adapter.setAll(draft.data, action.payload);
        draft.error = null;
        draft.loading = false;
      },
      removeOne(draft, action) {
        if (!adapter?.removeOne) return;
        adapter.removeOne(draft.data, action.payload);
        draft.error = null;
        draft.loading = false;
      },
      removeMany(draft, action) {
        if (!adapter?.removeMany) return;
        adapter.removeMany(draft.data, action.payload);
        draft.error = null;
        draft.loading = false;
      },
      removeAll(draft) {
        if (!adapter?.removeAll) return;
        adapter.removeAll(draft.data);
        draft.error = null;
        draft.loading = false;
      },
      update(draft, action) {
        draft.data = { ...draft.data, ...action.payload };
        draft.error = null;
        draft.loading = false;
      },
      updateOne(draft, action) {
        if (!adapter?.updateOne) return;
        adapter.updateOne(draft.data, action.payload);
        draft.error = null;
        draft.loading = false;
      },
      updateMany(draft, action) {
        if (!adapter?.updateMany) return;
        adapter.updateMany(draft.data, action.payload);
        draft.error = null;
        draft.loading = false;
      },
      upsertOne(draft, action) {
        if (!adapter?.upsertOne) return;
        adapter.upsertOne(draft.data, action.payload);
        draft.error = null;
        draft.loading = false;
      },
      upsertMany(draft, action) {
        if (!adapter?.upsertMany) return;
        adapter.upsertMany(draft.data, action.payload);
        draft.error = null;
        draft.loading = false;
      },
      ...reducers,
    },
  });
}

export { asyncSlice };
